import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import styles from '../AssortmentPanel.module.scss?module';

export type LineSheetOwnership = 'all' | 'stocked';
export type LineSheetSort = 'relevance' | 'name' | 'price-asc' | 'price-desc';

const SORT_OPTIONS: { value: LineSheetSort; label: string }[] = [
  { value: 'relevance', label: 'Relevance' },
  { value: 'name', label: 'Name A–Z' },
  { value: 'price-asc', label: 'Price low–high' },
  { value: 'price-desc', label: 'Price high–low' },
];

function isSort(value: string): value is LineSheetSort {
  return SORT_OPTIONS.some((option) => option.value === value);
}

interface LineSheetToolbarProps {
  search: string;
  onSearchChange: (value: string) => void;
  ownership: LineSheetOwnership;
  onOwnershipChange: (value: LineSheetOwnership) => void;
  /** False hides "My products", e.g. when the stocked items are unknown. */
  showOwnership: boolean;
  /** Selected category name, '' for all. */
  category: string;
  categories: string[];
  onCategoryChange: (value: string) => void;
  sort: LineSheetSort;
  onSortChange: (value: LineSheetSort) => void;
}

/** Search, "My products", category and sort above the line sheet. */
export default function LineSheetToolbar({
  search,
  onSearchChange,
  ownership,
  onOwnershipChange,
  showOwnership,
  category,
  categories,
  onCategoryChange,
  sort,
  onSortChange,
}: LineSheetToolbarProps) {
  return (
    <div className={styles.toolbar}>
      <div className={styles.searchField}>
        <FontAwesomeIcon
          icon={faMagnifyingGlass}
          className={styles.searchIcon}
          aria-hidden="true"
        />
        <input
          type="search"
          className={styles.searchInput}
          value={search}
          onChange={(event) => onSearchChange(event.target.value)}
          placeholder="Search products …"
          aria-label="Search products"
          autoComplete="off"
          spellCheck={false}
        />
      </div>
      <div className={styles.selects}>
        {showOwnership && (
          <select
            className={styles.select}
            value={ownership}
            onChange={(event) =>
              onOwnershipChange(
                event.target.value === 'stocked' ? 'stocked' : 'all'
              )
            }
            aria-label="My products"
          >
            <option value="all">All products</option>
            <option value="stocked">Products you stock</option>
          </select>
        )}
        <select
          className={styles.select}
          value={category}
          onChange={(event) => onCategoryChange(event.target.value)}
          aria-label="Category"
        >
          <option value="">All categories</option>
          {categories.map((name) => (
            <option key={name} value={name}>
              {name}
            </option>
          ))}
        </select>
        <select
          className={styles.select}
          value={sort}
          onChange={(event) => {
            const value = event.target.value;
            onSortChange(isSort(value) ? value : 'relevance');
          }}
          aria-label="Sort"
        >
          {SORT_OPTIONS.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
